import { PricesBlock, PricesBlockProps } from "@silversea-ssc/ui-components-react"
import { SuitePrice } from "@ssc-booking/api-contracts"
import { suitePriceToFormattedPrice } from "./utils"

type FormattedPricesBlockProps = Omit<PricesBlockProps, "priceFrom"> & {
    price: SuitePrice
}
const FormattedPricesBlock: React.FC<FormattedPricesBlockProps> = ({ price, ...props }) => {
    return <PricesBlock {...props} prices={[suitePriceToFormattedPrice(price)]} />
}

export default FormattedPricesBlock
